if (!customElements.get('slider-dots')) {
  class SliderDots extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        button: '.slider-bar',
        sliderComponent: 'slider-component',
        currentIndex: '.slider-counter--current',
        buttonNext: '.slider-button--next',
        buttonPrev: '.slider-button--prev',
        slide: '.slider__slide',
        sliderList: '.slider',
        sliderCounter: '.slider-counter--total'
      };
      this.lastKnownIndexText = 0;
      setTimeout(() => this.init(), 1000);
    }

    init() {
      const sliderComponent = this.closest('slider-component');
      this.currentIndexEl = sliderComponent.querySelector(this.selector.currentIndex);
      this.nextButton = sliderComponent.querySelector(this.selector.buttonNext);
      this.prevButton = sliderComponent.querySelector(this.selector.buttonPrev);
      this.buttons = this.querySelectorAll(this.selector.button);
      this.sliderComponent = this.closest(this.selector.sliderComponent);
      this.slides = this.sliderComponent?.querySelectorAll(this.selector.slide);
      this.sliderList = this.sliderComponent?.querySelector(this.selector.sliderList);
      this.totalEl = this.sliderComponent.querySelector(this.selector.sliderCounter);

      if (this.sliderComponent && this.slides && this.sliderList) {
        const totalSlides = this.slides.length;
        this.updateDotsVisibility();
        this.logVisibleSlides();
      }

      this.buttons?.forEach((button, index) => {
        button?.addEventListener('click', () => {
          this.handleClick(button, index);
        });
      });

      if (this.currentIndexEl) {
        this.startMonitoringTextContent();
      }

      window.addEventListener('resize', () => this.updateDotsVisibility());
    }

    startMonitoringTextContent() {
      this.lastKnownIndexText = this.currentIndexEl.textContent;
      this.textContentCheckInterval = setInterval(() => {
        const currentText = this.currentIndexEl.textContent;
        if (currentText !== this.lastKnownIndexText) {
          const currentNumber = Number(currentText);
          this.updateActiveButton(this.buttons[currentNumber - 1]);
          this.lastKnownIndexText = currentText;
          this.logVisibleSlides();
          this.updateDotsVisibility();
          // this.updateSliderScroll(); 
        }
      }, 100);
    }

    handleClick(clickedButton, index) {
      const targetIndex = index + 1; // 1-based index
      this.currentIndexEl.textContent = targetIndex;
      this.updateSliderScroll();
      this.updateActiveButton(clickedButton);
      this.logVisibleSlides();
      this.updateDotsVisibility();
    }

    updateSliderScroll() {
      if (!this.sliderList || !this.slides.length) return;

      const targetIndex = Number(this.currentIndexEl.textContent) - 1; // 0-based
      const targetSlide = this.slides[targetIndex];
      if (!targetSlide) return;

      // Calculate scroll position to align target slide as the first visible slide
      const scrollLeft = targetSlide.offsetLeft;

      // Scroll the slider horizontally with smooth behavior
      this.sliderList.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });

      // Dispatch event for compatibility
      const event = new CustomEvent('slider-index-changed', {
        detail: { currentIndex: Number(this.currentIndexEl.textContent) },
        bubbles: true,
      });
      this.sliderComponent.dispatchEvent(event);
    }

    updateActiveButton(newActiveButton) {
      this.buttons.forEach(button => {
        button.classList.remove('active');
      });
      if (newActiveButton) { newActiveButton.classList.add('active'); }
    }

    logVisibleSlides() {
      if (!this.sliderComponent || !this.slides) return;

      const visibleSlidesCount = this.getVisibleSlidesCount();
      const currentIndex = Number(this.currentIndexEl.textContent) - 1; // 0-based
      const totalSlides = this.slides.length;

      const visibleIndices = [];
      for (let i = 0; i < visibleSlidesCount && currentIndex + i < totalSlides; i++) {
        visibleIndices.push(currentIndex + i + 1); // 1-based for logging
      }
    }

    getVisibleSlidesCount() {
      const slidesPerView = this.sliderComponent.dataset.slidesPerView
        ? Number(this.sliderComponent.dataset.slidesPerView)
        : this.inferVisibleSlidesCount();
      return Math.min(slidesPerView, this.slides.length) || 1;
    }

    inferVisibleSlidesCount() {
      let visibleCount = 0;
      this.slides.forEach(slide => {
        const rect = slide.getBoundingClientRect();
        const isVisible = rect.width > 0 && rect.height > 0 && rect.left >= 0 && rect.left < window.innerWidth;
        if (isVisible) visibleCount++;
      });
      return visibleCount || 1;
    }

    updateDotsVisibility() {
      if (!this.sliderComponent || !this.buttons || !this.totalEl) return;

      const totalSlides = Number(this.totalEl.textContent) || 1;

      this.buttons.forEach((button, index) => {
        if (index < totalSlides) {
          button.classList.remove('hidden');
        } else {
          button.classList.add('hidden');
        }
      });
    }

  }

  customElements.define('slider-dots', SliderDots);
}